import { identity } from "lodash"

export const dontWrapObserver = identity
